<template>
  <div class="hello">
    <vue-progress-bar :show="true" reference="example"></vue-progress-bar>
    
    <table id="links-list">
      <tr>
        <td class="container primary">
        <div class="text" @click="start('example')">Start</div>
        </td>
        <td class="container secondary">
        <div class="text"  @click="finish('example')">Finish</div>
        </td>
        <td class="container danger">
        <div class="text" @click="fail('example')">Fail</div>
        </td>
      </tr>
      <tr>
        <td class="container default">
          <input class="check" type="checkbox" v-model="trail.use"><span @click="trail.use = !trail.use" class="text">{{checkboxes.trail}}<br></span>
            <input placeholder="100" class="data" v-if="trail.use" type="number" v-model="trail.data"></input>
          </input>
        </td>

        <td class="container default">
          <input class="check" type="checkbox" v-model="thickness.use"><span @click="thickness.use = !thickness.use" class="text">{{checkboxes.thickness}}<br></span>
            <input placeholder="10" class="data" v-if="thickness.use" type="number" v-model="thickness.data"></input>
          </input>
        </td>

        <td class="container default">
          <input class="check" type="checkbox" v-model="color.use"><span @click="color.use = !color.use" class="text">{{checkboxes.sColor}}<br></span>
            <input placeholder="#00A1FF" class="data" v-if="color.use" type="text" v-model="color.data"></input>
          </input>
        </td>
      </tr>
      <tr>
        <td class="container default">
          <input class="check" type="checkbox" v-model="gradient.use"><span @click="gradient.use = !gradient.use" class="text">{{checkboxes.gradient}}<br></span>
            <input placeholder="predefined" class="data" v-if="gradient.use" type="text" v-model="gradient.data"></input>
          </input>
        </td>
        <td class="container default">
          <input class="check" type="checkbox" v-model="failColor.use"><span @click="failColor.use = !failColor.use" class="text">{{checkboxes.fColor}}<br></span>
            <input placeholder="red" class="data" v-if="failColor.use" type="text" v-model="failColor.data"></input>
          </input>
        </td>
        <td class="container default">
          <input class="check" type="checkbox" v-model="transition.use"><span @click="transition.use = !transition.use" class="text">{{checkboxes.transition}}</span>
            <span v-if="transition.use" class="text"><br>Time <input placeholder="2" class="data"  type="number" v-model="transition.time"></input></span>
            <span v-if="transition.use" class="text"><br>Opacity <input placeholder="2" class="data"  type="number" v-model="transition.opacity"></input></span>
          </input>
        </td>
        
      </tr>
      <tr>
        <td class="container default">
          <select class="text" v-model="locations.location">
            <option value="top">Top</option>
            <option value="bottom">Bottom</option>
            <option value="left">Left</option>
            <option value="right">Right</option>
          </select>
        </td>
        <td class="container default">
          <input class="check" type="checkbox" v-model="bounce.use"><span @click="bounce.use = !bounce.use" class="text">{{checkboxes.bounce}}</span>
          </input>
        </td>

        <td class="container default">
          <input class="check" type="checkbox" v-model="inverse.use"><span @click="inverse.use = !inverse.use" class="text">{{checkboxes.inverse}}</span>
          </input>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'hello',
  mounted () {
    this.$pb.start('example')
  },
  data () {
    return {
      checkboxes: {transition: 'Transition', trail: 'Trail', fColor: 'Fail Color', sColor: 'Color', gradient: 'Gradient', bounce: 'Bounce', inverse: 'Inverse', thickness: 'Thickness'},
      locations: {options: ['top', 'bottom', 'left', 'right'], location: 'top'},
      failColor: {use: false, data: ''},
      color: {use: false, data: ''},
      gradient: {use: false, data: ''},
      inverse: {use: false},
      bounce: {use: false},
      transition: {use: false, time: '', opacity: ''},
      trail: {use: false, data: ''},
      thickness: {use: false, data: ''}
    }
  },
  methods: {
    start (bName) {
      let modifications = []
      this.failColor.use ? modifications.push({call: 'fail', modifier: 'temp', argument: this.failColor.data}) : modifications.push({call: 'fail', modifier: 'temp', argument: '#ff0000'})
      this.color.use ? modifications.push({call: 'color', modifier: 'temp', argument: this.color.data}) : modifications.push({call: 'color', modifier: 'temp', argument: '#178BA1'})
      this.gradient.use ? modifications.push({call: 'gradient', modifier: 'temp', argument: {use: this.gradient.use, gradient: this.gradient.data}}) : null
      this.inverse.use ? modifications.push({call: 'inverse', modifier: 'temp', argument: true}) : modifications.push({call: 'inverse', modifier: 'temp', argument: false})
      this.bounce.use ? modifications.push({call: 'bounce', modifier: 'temp', argument: true}) : modifications.push({call: 'bounce', modifier: 'temp', argument: false})
      this.transition.use ? modifications.push({call: 'transition', modifier: 'temp', argument: {time: this.transition.time + 's', opacity: this.transition.opacity + 's'}}) : null
      this.trail.use && this.trail.data !== '' ? modifications.push({call: 'trail', modifier: 'temp', argument: this.trail.data + 'px'}) : modifications.push({call: 'trail', modifier: 'temp', argument: '-1px'})
      this.thickness.use && this.thickness.data !== '' ? modifications.push({call: 'thickness', modifier: 'temp', argument: this.thickness.data + 'px'}) : modifications.push({call: 'thickness', modifier: 'temp', argument: '20px'})
      modifications.push({call: 'location', modifier: 'temp', argument: this.locations.location})
      this.$pb.start(bName, modifications, 'meta')
    },
    finish (bName) {
      this.$pb.finish(bName)
    },
    fail (bName) {
      this.$pb.fail(bName)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#links-list {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}
select {
  cursor: pointer;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.7);
}
option {
  background: #525252;
}
.text {
  font-family: Open Sans;
  font-size: x-large;
}
.primary {
  border-color: rgba(0, 255, 69, 0.2);
}
.primary:hover {
  -webkit-box-shadow: 0px 1px 3px #3CB918, inset 2px 2px 3px #3CB918, inset -2px -2px 3px #3CB918 !important;
  -moz-box-shadow: 0px 1px 3px #3CB918, inset 2px 2px 3px #3CB918, inset -2px -2px 3px #3CB918 !important;
  box-shadow: 0px 1px 3px #3CB918, inset 2px 2px 3px #3CB918, inset -2px -2px 3px #3CB918 !important;
}
.secondary {
  border-color: rgba(177, 255, 0, 0.2);
}
.secondary:hover {
  -webkit-box-shadow: 0px 1px 3px #B98C18, inset 2px 2px 3px #B98C18, inset -2px -2px 3px #B98C18 !important;
  -moz-box-shadow: 0px 1px 3px #B98C18, inset 2px 2px 3px #B98C18, inset -2px -2px 3px #B98C18 !important;
  box-shadow: 0px 1px 3px #B98C18, inset 2px 2px 3px #B98C18, inset -2px -2px 3px #B98C18 !important;
}
.danger {
  border-color: rgba(255, 0, 0, 0.2);
}
.danger:hover {
  -webkit-box-shadow: 0px 1px 3px #A11717, inset 2px 2px 3px #A11717, inset -2px -2px 3px #A11717 !important;
  -moz-box-shadow: 0px 1px 3px #A11717, inset 2px 2px 3px #A11717, inset -2px -2px 3px #A11717 !important;
  box-shadow: 0px 1px 3px #A11717, inset 2px 2px 3px #A11717, inset -2px -2px 3px #A11717 !important;
}
.default {
  border-color: rgba(43, 0, 255, 0.2);
}
.default:hover {
  -webkit-box-shadow: 0px 1px 3px #7217A1, inset 2px 2px 3px #7217A1, inset -2px -2px 3px #7217A1 !important;
  -moz-box-shadow: 0px 1px 3px #7217A1, inset 2px 2px 3px #7217A1, inset -2px -2px 3px #7217A1 !important;
  box-shadow: 0px 1px 3px #310648, inset 2px 2px 3px #310648, inset -2px -2px 3px #310648 !important;
}
.container {
  cursor: pointer;
  position: relative;
  padding: 5px;
  display: inline-block;
  margin: 5px;
  color: rgba(255, 255, 255, 0.7);
  background-color: rgba(255, 255, 255, 0.08);
  transition: color 0.2s, background-color 0.2s, border-color 0.2s, box-shadow 0.2s;
  border-style: solid;
  border-width: 1px;
  border-radius: 0.3rem;
}
.container:hover{
  /** box shadow */
  -webkit-box-shadow: 0px 1px 3px #178BA1, inset 2px 2px 3px #178BA1, inset -2px -2px 3px #178BA1;
  -moz-box-shadow: 0px 1px 3px #178BA1, inset 2px 2px 3px #178BA1, inset -2px -2px 3px #178BA1;
  box-shadow: 0px 1px 3px #178BA1, inset 2px 2px 3px #178BA1, inset -2px -2px 3px #178BA1;
}
.data {
  width: auto;
  font-size: medium;
  text-align: center;
  border: none;
  display:block;
  border-bottom:1px solid #757575;
}
data:focus { 
  outline: none; 
}
.check {
  left: 13px;
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// Hello.vue?31dee865